import QuickInteractionModal from 'apps/outreach/components/quick-interaction-modal';
import { useGlobalDrawerProvider } from './context/global-drawer-context';
import DNDComponents from 'components/controls/dnd-components/dnd-components';
import { useGlobalOutreachProvider } from 'apps/outreach/contexts/global-outreach-context';
import { updateCall } from 'components/dialer/voip-services/twilio/utils/twilio-utils';

const DrawerContainer = () => {
  const { drawers, disableDragAndDrop } = useGlobalDrawerProvider();
  const { isQuickInteractionOpen, quickInteractionData, closeQuickInteraction } = useGlobalOutreachProvider();
  const { emailId, emailCreatorId, updateSent, call } = quickInteractionData;

  // Prepare the draggable items
  const draggableItems = drawers.map(({ id, drawer }) => ({
    id,
    component: drawer(),
  }));

  const handleAfterSubmitInteraction = async (interaction) => {
    // If emailId is present, update the sent email with interaction_id
    if (emailId) {
      const payload = {
        interaction_id: interaction.id,
        creator_user_id: emailCreatorId,
      };
      await updateSent(payload, emailId);
    }
    // If call id is present, update the call with interaction_id
    if (call?.id) {
      const payload = {
        interaction_id: interaction.id,
        call_notes: call.call_notes,
      };
      await updateCall(call.id, payload);
    }
  };

  return (
    <>
      <DNDComponents
        items={draggableItems}
        itemsClassName="drawers-container"
        ignoreContainerClipping={true}
        isDragDisabled={disableDragAndDrop}
      />
      {isQuickInteractionOpen && (
        <QuickInteractionModal
          isOpen={isQuickInteractionOpen}
          closeModal={() => {
            closeQuickInteraction();
            if (typeof quickInteractionData.onClose === 'function') {
              quickInteractionData.onClose();
            }
          }}
          afterSubmit={handleAfterSubmitInteraction}
          {...quickInteractionData}
        />
      )}
    </>
  );
};

export default DrawerContainer;
